{
  "abox": {
    "asRole": "als",
    "counts": "{{statements}} · {{individuals}}",
    "detailLevel": "Detailgrad",
    "download": "N-Quads herunterladen",
    "evidence": "Belege",
    "levels": {"details": "Details", "essentials": "Wesentliches", "technical": "Technisch"},
    "overview": "Übersicht",
    "provenance": "Herkunft",
    "sourceUnavailable": "Diese Dokumentreferenz ist nicht verfügbar.",
    "technical": "Technische Details",
    "title": "Aussagen"
  },
  "counts": {
    "individuals_one": "{{count}} Individuum",
    "individuals_other": "{{count}} Individuen",
    "newerProposals_one": "{{count}} neuerer Vorschlag",
    "newerProposals_other": "{{count}} neuere Vorschläge",
    "statements_one": "{{count}} Aussage",
    "statements_other": "{{count}} Aussagen"
  },
  "curation": {
    "accept": "In die Wissensdaten aufnehmen",
    "by": "von {{name}}, {{time}}",
    "by_you": "von Ihnen, {{time}}",
    "comment": "Kommentar (zum Ablehnen nötig)",
    "kinds": {
      "accept": "Angenommen",
      "carried_forward": "Fortgeführt",
      "reject": "Abgelehnt",
      "supersede": "Abgelöst",
      "withdraw": "Zurückgezogen"
    },
    "notCurator": "Über dieses Ergebnis entscheidet eine Kuratorin oder ein Kurator seiner Labelliste.",
    "reject": "Ablehnen",
    "title": "Kuratierung"
  },
  "dataset": {
    "copyDigest": "Prüfsumme des Pakets kopieren",
    "copyIri": "IRI des Datensatzes kopieren",
    "earlierRevision": "Frühere Revision; standardmäßig nicht ausgewählt.",
    "fields": {
      "description": "Beschreibung",
      "licence": "Lizenz",
      "licenceHelp": "Ein SPDX-Bezeichner wie CC-BY-4.0 oder die Adresse einer Lizenz.",
      "title": "Titel"
    },
    "metadata": "Metadaten",
    "noAccepted": "Noch keine angenommenen Ergebnisse.",
    "noVersions": "Noch keine Version.",
    "oneRevision": "Die Auswahl einer Revision ersetzt die bisher gewählte Revision derselben Versionslinie.",
    "problems": {
      "multipleRevisions": "{{members}}: Revisionen derselben Versionslinie ({{lineage}}); behalten Sie eine. Ihre angenommene Fassung ist {{head}}.",
      "multipleRevisionsNoHead": "{{members}}: Revisionen derselben Versionslinie ({{lineage}}); behalten Sie eine. Sie hat keine angenommene Fassung.",
      "notAccepted": "{{extraction}}: {{state}}, nicht angenommen.",
      "notFound": "{{extraction}}: kein Ergebnis dieses Projekts."
    },
    "replaces": "Ersetzt das frühere Ergebnis: {{sources}}",
    "versionFacts_one": "{{count}} Ergebnis, von {{name}}, {{time}}",
    "versionFacts_other": "{{count}} Ergebnisse, von {{name}}, {{time}}",
    "versions": "Versionen",
    "versionsImmutable": "Eine Version ändert sich nie: Sie lädt jedes Mal genau dieselben Bytes herunter."
  },
  "export": {
    "formats": {"nquads": "N-Quads", "trig": "TriG"},
    "quads_one": "{{count}} Quad",
    "quads_other": "{{count}} Quads"
  },
  "extraction": {
    "copyIri": "IRI des Ergebnisses kopieren",
    "generatedWhen": "{{generation}}, {{time}}",
    "instanceHint": "Jede Aussage zeigt die Stelle der Quelle, die sie belegt. Individuen behalten ihre IRI, wenn jemand das Ergebnis im Review ändert.",
    "instanceStatements_one": "{{count}} Aussage",
    "instanceStatements_other": "{{count}} Aussagen",
    "openThread": "Im Durchlauf öffnen",
    "saysTriples": "Was sie sagt",
    "showTriples": "Technische Details: die Tripel",
    "statementsFrom": "Aussagen aus <document/>",
    "title": "Extraktionsergebnis"
  },
  "generation": {
    "agent_turn": "Agentenschritt",
    "carried_forward": "Fortgeführt",
    "human_review": "Von einer Person gesichtet"
  },
  "index": {
    "annotations_one": "{{count}} Annotation",
    "annotations_other": "{{count}} Annotationen",
    "statementsResults_one": "{{count}} Ergebnis",
    "statementsResults_other": "{{count}} Ergebnisse",
    "statements_one": "{{count}} Aussage",
    "statements_other": "{{count}} Aussagen"
  },
  "lenses": {
    "term": {
      "byState": "{{state}}: {{uses}}",
      "individuals_one": "{{count}} Individuum",
      "individuals_other": "{{count}} Individuen",
      "none": "Noch keine Aussage verwendet diesen Begriff.",
      "statements_one": "{{count}} Aussage",
      "statements_other": "{{count}} Aussagen"
    }
  },
  "lineage": {
    "closed": "Geschlossene Vorschläge:",
    "confirm_one": "Diese Übernahme schließt {{count}} neueren Vorschlag. Fortfahren?",
    "confirm_other": "Diese Übernahme schließt {{count}} neuere Vorschläge. Fortfahren?",
    "inbox": "Wissensdaten",
    "inboxEntry": "{{statements}} · von {{name}}, {{time}} · {{newer}}",
    "inboxEntry_you": "{{statements}} · von Ihnen, {{time}} · {{newer}}",
    "merge": "In die Wissensdaten des Projekts übernehmen",
    "newer": "Es gibt einen neueren Vorschlag (von {{name}}, {{time}})",
    "newer_you": "Es gibt einen neueren Vorschlag (von Ihnen, {{time}})",
    "notCurator": "Ein Kurator der Wissensdaten des Projekts entscheidet darüber.",
    "pending": "Offener Vorschlag (von {{name}}, {{time}})",
    "pending_you": "Offener Vorschlag (von Ihnen, {{time}})",
    "skipped": "Bereits entschieden; übersprungen: {{sources}}",
    "workingState": "Arbeitsstand von {{name}}",
    "workingState_you": "Arbeitsstand von Ihnen"
  },
  "openResearchSpace": "In ResearchSpace öffnen",
  "provenance": {
    "entry": "Durchlauf-Eintrag {{entry}}",
    "recordedOnly": "Von DMW erfasst.",
    "review": "Review von {{name}}",
    "review_you": "Ihr Review",
    "rows": {
      "agent": "Agent",
      "corpusVersion": "Korpusversion",
      "curator": "Kuratierung",
      "finished": "Beendet",
      "generatedBy": "Erzeugt durch",
      "host": "Lief auf dem PC von",
      "inputDigest": "Prüfsumme der Eingabe",
      "mapping": "Herkunftsabbildung",
      "model": "LLM",
      "prompt": "Prompt",
      "referencesRead": "Gelesene Versionen",
      "requestedBy": "Angefordert von",
      "reviewedOutput": "Gesichtetes Ergebnis",
      "route": "LLM-Route",
      "started": "Begonnen",
      "step": "Schritt",
      "stepKey": "Schrittschlüssel",
      "threadEntry": "Durchlauf",
      "workflow": "Prozessschema"
    },
    "runEntry": "{{run}} · Eintrag {{entry}}",
    "title": "Herkunft"
  },
  "release": {
    "button": "Neue Datenveröffentlichung…",
    "download": "Herunterladen",
    "downloadAlways": "Jede Datenveröffentlichung lässt sich auch als Datei herunterladen (N-Quads oder TriG), jedes Mal genau dieselben Bytes.",
    "metadataFirst": "Das ist die erste Datenveröffentlichung des Projekts: Sie legt die Reihe der Datenveröffentlichungen an. Geben Sie ihr einen Titel und eine Lizenz.",
    "metadataFromLast": "Wie in der letzten Datenveröffentlichung; Änderungen gelten ab dieser.",
    "metadataInDialog": "Titel, Lizenz und Beschreibung werden im Schritt „Die Veröffentlichung beschreiben“ des Prozessschemas zur Datenveröffentlichung gesetzt.",
    "modelVersionHint": "Die Datenveröffentlichung wird als Ganzes gegen diese Version geprüft: die Begriffe jedes Ergebnisses, dann Shapes und Konsistenz der zusammengeführten Ergebnisse. Eine Datenveröffentlichung, die nicht besteht, wird nicht erstellt.",
    "newestVersion": "{{name}} ({{time}}, neueste)",
    "noModelVersion": "Dieses Projekt hat noch keine Inhaltsversion. Eine Datenveröffentlichung wird gegen eine geprüft.",
    "noResearchSpace": "ResearchSpace ist auf dieser Installation nicht eingerichtet.",
    "none": "Noch keine Datenveröffentlichung.",
    "number": "Datenveröffentlichung {{number}}",
    "numberWithTitle": "Datenveröffentlichung {{number}} · {{title}}",
    "olderVersion": "{{name}} ({{time}})",
    "projectOff": "Dieses Projekt veröffentlicht nicht in ResearchSpace. Die Projektadministration kann es in den Einstellungen des Projekts einschalten.",
    "results": "Angenommene Ergebnisse",
    "step": {
      "members_one": "{{count}} Ergebnis",
      "members_other": "{{count}} Ergebnisse",
      "missingRequest": "Dieser Schritt baut auf der Veröffentlichungsanfrage auf, die der Schritt davor noch nicht geliefert hat.",
      "sendWhat_one": "Senden: {{count}} Ergebnis",
      "sendWhat_other": "Senden: {{count}} Ergebnisse",
      "staysInDmw": "Bleibt in DMW, als Datei herunterladbar",
      "toResearchSpace": "Auch in ResearchSpace veröffentlicht"
    },
    "toResearchSpace": "In ResearchSpace veröffentlichen",
    "versions": "Versionen"
  },
  "releaseChecks": {
    "against": "Jeder Bestandteil wurde gegen das Datenmodell der für die Datenveröffentlichung gewählten Inhaltsversion geprüft, Datenmodell-Snapshot",
    "attributionPartial": "Die Prüfmaschine hat nur einen Teil der Shapes-Befunde aufgeführt, daher werden Bestandteile nur nach den aufgeführten benannt. Ein Bestandteil, den keiner davon betrifft, ist „nicht bestimmt“, nicht bestanden.",
    "downloadUnchecked": "Ungeprüft: Diese Version wurde vor den Veröffentlichungsprüfungen angelegt. Das Paket ist unverändert, wurde aber nie als Ganzes geprüft.",
    "engine": "Geprüft von {{engine}}.",
    "hide": "Veröffentlichungsprüfungen ausblenden",
    "members": "Jeder Bestandteil: die Begriffe des Datenmodells und die Shapes-Verletzungen, an denen er beteiligt ist",
    "merged": "Die zusammengeführte Datenveröffentlichung: Konsistenz",
    "mergedShapes": "Die zusammengeführte Datenveröffentlichung: Shapes",
    "noInstanceData": "Ein Annotationsergebnis: Es sagt nichts über das Datenmodell aus, was Shapes oder Regeln prüfen könnten.",
    "noShapes": "Das Datenmodell dieser Inhaltsversion hat keine Shapes, daher wurden nur seine Begriffe geprüft.",
    "notDetermined": "Shapes-Ergebnis nicht bestimmt: Kein aufgeführter Befund betrifft ihn, aber einige Befunde sind nicht aufgeführt.",
    "older": "Gegen eine ältere Inhaltsversion erstellt, {{version}}; gegen diese erneut geprüft, nicht hochgestuft.",
    "outcomes": "Begriffe: {{terms}} · Shapes: {{shapes}}",
    "shortened": "Dieser Bericht hält seine Größengrenze ein: Einige lange Texte sind gekürzt, und einige Befunde oder Gründe sind nicht aufgeführt. Jeder Status und jede Anzahl ist vollständig.",
    "show": "Veröffentlichungsprüfungen: {{status}}, gegen Datenmodell-Snapshot {{version}}. Bericht anzeigen",
    "statementProblem": "Aussage {{number}}: {{reason}}",
    "status": {
      "cannot_run": "Nicht ausführbar",
      "fail": "Fehlgeschlagen",
      "no_instance_data": "Nichts zu prüfen",
      "not_determined": "Nicht bestimmt",
      "pass": "Bestanden"
    },
    "unchecked": "Nicht als Ganzes geprüft: vor den Veröffentlichungsprüfungen angelegt. Sie bleibt gültig und lässt sich wie bisher herunterladen, aber nicht in ResearchSpace veröffentlichen. Erstellen Sie aus denselben Ergebnissen erneut eine Datenveröffentlichung, um sie zu prüfen.",
    "uncheckedFormat": "{{format}} (ungeprüft)",
    "unlisted": "Gründe nicht aufgeführt: Der Bericht führt sie nur für die ersten nicht bestandenen Bestandteile auf."
  },
  "researchSpace": {
    "administration": {
      "connected": "Verbunden",
      "connection": "Verbindung",
      "hint": "Das eine ResearchSpace dieser Installation. Seine Verbindung steht in der Konfiguration des Servers ([data.researchspace]); jedes Projekt schaltet das Veröffentlichen in seinen Regeln ein.",
      "running": "Zustand",
      "title": "ResearchSpace"
    },
    "label": "ResearchSpace",
    "notPublished": "Nicht veröffentlicht",
    "publish": "In ResearchSpace veröffentlichen",
    "publishing": "Wird veröffentlicht…",
    "replaced": "Ersetzt",
    "runtime": {
      "running": "ResearchSpace läuft",
      "stopped": "ResearchSpace ist gestoppt",
      "unreachable": "ResearchSpace antwortet nicht"
    },
    "states": {
      "applying": "Wird neu geladen",
      "configuring": "Seiten werden vorbereitet",
      "exporting": "Wird veröffentlicht",
      "failed": "Fehlgeschlagen",
      "published": "In ResearchSpace",
      "requested": "Angefordert"
    }
  },
  "review": {
    "noResult": "Dieser Schritt nennt kein Ergebnis, über das zu entscheiden ist.",
    "open": "Review öffnen",
    "record": "Entscheidung in diesem Schritt festhalten"
  },
  "states": {
    "accepted": "Angenommen",
    "proposed": "Vorgeschlagen",
    "rejected": "Abgelehnt",
    "superseded": "Abgelöst",
    "withdrawn": "Zurückgezogen"
  }
}
